<template>
  <div class="flex dialog-content multiple">
    <div class="left-content overflow-y no--sb">
      <h5 class="title">細身</h5>
      <div class="button-container" v-for="(data, idx) in smallSize" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
        <span v-if="currentRoute === 'step1'"
              class="chip rounded"></span>
          <span class="text">{{data.name}}</span>
          <span class="detail" @click="toggleSubDialog(data, true)">詳しく</span>
        </button>
      </div>
      <h5 class="title">普通幅</h5>
      <div class="button-container" v-for="(data, idx) in midSize" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
        <span v-if="currentRoute === 'step1'"
              class="chip rounded"></span>
          <span class="text">{{data.name}}</span>
          <span class="detail" @click="toggleSubDialog(data, true)">詳しく</span>
        </button>
      </div>
      <h5 class="title">幅広</h5>
      <div class="button-container" v-for="(data, idx) in bigSize" :key="idx">
        <button class="flex align-center rounded pointer"
                :class="{active: selectedItem && selectedItem.val === data.val}"
                @click="storeItem(data)">
        <span v-if="currentRoute === 'step1'"
              class="chip rounded"></span>
          <span class="text">{{data.name}}</span>
          <span class="detail" @click="toggleSubDialog(data, true)">詳しく</span>
        </button>
      </div>

      <div class="oval flex caution-container">
        <i class="fas fa-info-circle"></i>
        <p>4.0mm幅以上をご希望の方は個別にお見積もりいたします。<br> シミュレーター上では3.8mmを選択の上、オーダー最後の自由欄にご希望のサイズをご入力ください。 K18グリーンゴールドは強度面からできましたら2.2幅以上をお選びください。</p>
      </div>
    </div>

    <div class="right-content">
      <figure class="relative">
        <img class="oval" :src="currentImage(selectedItem)" alt="image">
        <div v-if="selectedItem && !applyRule(selectedItem.val).visible" class="flex align-center justify-center select-button rule-text">
          <div class="overlay"></div>
          <p class="warning">選択できません<br>{{applyRule(selectedItem.val).rule}}</p>
        </div>
        <transition name="slideUp">
          <div class="flex align-center justify-center select-button" v-if="selectedItem && applyRule(selectedItem.val).visible">
            <div class="overlay"></div>
            <button class="oval transition pointer" @click="selectItem()">選択</button>
          </div>
        </transition>
      </figure>

      <div class="oval flex caution-container">
        <i class="fas fa-info-circle"></i>
        <p>4.0mm幅以上をご希望の方は個別にお見積もりいたします。<br> シミュレーター上では3.8mmを選択の上、オーダー最後の自由欄にご希望のサイズをご入力ください。 K18グリーンゴールドは強度面からできましたら2.2幅以上をお選びください。</p>
      </div>

    </div>
  </div>
</template>

<script>
import useImageBuilder from "@/modules/moduleA/helpers/useImageBuilder";
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import useRules from "@/modules/moduleA/helpers/useRules";
import {ref} from "vue";
export default {
  name: "DiType3",
  props:{stepData:Array},
  setup(props){
    const {currentRoute, toggleSubDialog, storeItem, selectItem, selectedItem} = useDialogBuilder()
    const {currentImage} = useImageBuilder(currentRoute.value)
    const {applyRule} = useRules(currentRoute.value)

    const smallSize = ref([])
    const midSize = ref([])
    const bigSize = ref([])

    props.stepData.forEach(item => {
      if (item.tab === 1){smallSize.value.push(item)}
      else if (item.tab === 2){midSize.value.push(item)}
      else if (item.tab === 3){bigSize.value.push(item)}
      else{}
    })

    return {currentRoute, toggleSubDialog, storeItem, selectItem, selectedItem, currentImage, applyRule, smallSize, midSize, bigSize}
  }
}
</script>

<style scoped>
.dialog-content > .left-content > .caution-container {
    display: none;
  }
  .dialog-content > .left-content > .caution-container,
  .dialog-content > .right-content > .caution-container {
    margin-top: 20px;
    background-color: #f5f6fa;
    padding: 10px;
  }
  .dialog-content > .left-content > .caution-container > p,
  .dialog-content > .right-content > .caution-container > p {
    margin-left: 10px;
    font-size: .8rem;
  }

  @media screen and (max-width: 736px){
    .dialog-content > .left-content > .caution-container {
      display: block;
    }
    .dialog-content > .right-content > .caution-container {
      display: none;
    }
  }
</style>